import { Id, RecordAny } from "@gemma/typescript-types";

import { Contractors } from "@timesheets/routes-app";
import { GemmaError } from "@gemma/errors";
import { Route } from "@gemma/utils";
import { Routing } from "@timesheets/webapp-support";
import { WebApplicationConstants } from "@/setup/WebApplicationConstants";

export function navigateToContractor(this: Vue, contractor: string | Id<string>, options: { searchTerms?: RecordAny } = {}) {
  const path = Contractors.Get(contractor);
  const route = new Route(path, options.searchTerms);
  Routing.ensureRoleIdOnUrl(route, this.currentRole);

  this.$router.push(route.fullPath).catch(error => {
    WebApplicationConstants.defaultLogger.warn(`Navigating to contractor failed (id: ${route.fullPath})`);
    WebApplicationConstants.defaultLogger.error(new GemmaError(error));
  });
}
